module.exports = __webpack_public_path__ + "static/img/company_history2001.c66a1d4c.jpg";